import { HTTP_VERBS } from "../../enums";
import { GetDeathCertDetailsFromDownloadResponseDO } from "../domainObjects";

export const httpVerb = HTTP_VERBS.GET;
export const url = "/api/v1/hdb-parking/death-cert";
export class Response extends GetDeathCertDetailsFromDownloadResponseDO {}
